<template>
    <div class="modal-card card">
        <div class="card-content">
            <div class="media">
                <div class="media-content">
                    <p
                        style="padding:0px"
                        class="title is-4"
                    >Lalamove Order</p>
                </div>
            </div>
            <div
                class="columns is-multiline"
                v-if="villaOrder"
            >
                <b-field
                    class="column is-6 py-0"
                    label="ผู้ส่ง (Villa Market)"
                >
                    <b-input v-model="villaOrder.requesterName"></b-input>
                </b-field>
                <b-field
                    class="column is-6 py-0"
                    label="หมายเลขโทรศัพท์ผู้ส่ง (Villa Market)"
                >
                    <b-input v-model="villaOrder.phoneVilla"></b-input>
                </b-field>
                <b-field
                    class="column is-12 pt-0"
                    label="ที่อยู่ (Villa Market)"
                >
                    <b-input
                        disabled
                        type="textarea"
                        v-model="villaOrder.originAddress"
                    ></b-input>
                </b-field>
                <b-field
                    class="column is-6 py-0"
                    label="ชื่อผู้รับ"
                >
                    <b-input v-model="villaOrder.name"></b-input>
                </b-field>
                <b-field
                    class="column is-6 py-0"
                    label="หมายเลขโทรศัพท์ผู้รับ"
                >
                    <b-input v-model="villaOrder.phone"></b-input>
                </b-field>
                <b-field
                    class="column is-12 py-0"
                    label="เลขที่/ห้อง/ชั้น"
                >
                    <b-input v-model="villaOrder.remark"></b-input>
                </b-field>
                <b-field
                    class="column is-12 py-0"
                    label="ที่อยู่จัดส่ง"
                >
                    <b-input
                        disabled
                        type="textarea"
                        v-model="modalAddress"
                    ></b-input>
                </b-field>
                <div class="column is-12 pt-0">
                    <b-button
                        type="is-danger is-light"
                        @click="onEditMapModal"
                        size="is-small"
                    >EDIT DESTINATION</b-button>
                </div>
            </div>
        </div>
        <footer class="modal-card-foot">
            <b-button
                class="column is-6"
                type="is-danger"
                outlined
                expanded
                @click="onClickClose"
            >Cancel</b-button>
            <b-button
                class="column is-6"
                type="is-success"
                outlined
                expanded
                @click="onClickConfirm"
            >Confirm</b-button>
        </footer>
    </div>
</template>

<script>
import EditMap from "../components/ModalMap.vue";
export default {
  name: "LalamoveEditOrder",
  props: ["villaOrderProp"],
  created() {
    console.log("villaOrder >>>", this.villaOrderProp);
    this.villaOrder = this.villaOrderProp;
    this.villaOrder.remark = null;
    this.villaOrder.phoneVilla = null;
    this.modalAddress = this.villaOrder.destinationAddress;
    this.modalLocation = this.villaOrder.destinationLocation;
  },
  data() {
    return {
      modalAddress: null,
      modalLocation: null,
    };
  },
  methods: {
    onEditMapModal() {
      this.$buefy.modal.open({
        parent: this,
        // fullScreen: true,
        props: {
          initLocation: this.villaOrder.destinationAddress,
          initLocationLatLng: this.villaOrder.destinationLocation,
        },
        component: EditMap,
        hasModalCard: true,
        trapFocus: true,
        events: {
          onConfirm: async (val) => {
            this.modalAddress = val.text;
            this.modalLocation = val.latlng;
            this.villaOrder.destinationAddress = this.modalAddress;
            this.villaOrder.destinationLocation = this.modalLocation;
          },
        },
      });
    },
    onClickConfirm() {
      console.log("to lalamove >>>", this.villaOrder);
      this.$emit("onConfirm", this.villaOrder);
      this.$emit("close");
    },
    onClickClose() {
      this.$emit("close");
    },
  },
};
</script>


<style>
.textarea:not([rows]) {
  min-height: 5em;
}
.modal-card {
  overflow-y: initial !important;
}
</style>
